import type { UserProfile } from '@bcc/shared';

export function profileDisplayName(p: UserProfile | null): string {
  if (!p) return 'User';
  return p.full_name?.trim() || p.email?.split('@')[0] || 'User';
}

export function profileInitials(p: UserProfile | null): string {
  if (!p) return '?';
  const n = p.full_name?.trim();
  if (n) {
    const parts = n.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
    return n.slice(0, 2).toUpperCase();
  }
  const e = p.email?.trim();
  if (e) return e.slice(0, 2).toUpperCase();
  return '?';
}
